var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.links)?_c('div',{staticClass:"d-flex flex-wrap gap-28",attrs:{"id":"alcor-tabs-components"}},_vm._l((_vm.tabs),function({ route, label, exact }){return _c('alcor-tab-link',{key:label,attrs:{"to":route,"exact":exact}},[_vm._v(_vm._s(_vm.$t(label)))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }